"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLoading = setLoading;
exports.setLoaded = setLoaded;
exports.setError = setError;
exports.monitorThunk = monitorThunk;

function setLoading(id) {
  return {
    type: "THUNKMONITOR/SET_LOADING",
    id: id
  };
}

function setLoaded(id) {
  return {
    type: "THUNKMONITOR/SET_LOADED",
    id: id
  };
}

function setError(id, error) {
  return {
    type: "THUNKMONITOR/SET_ERROR",
    id: id,
    error: error
  };
}

function monitorThunk(action, monitorId) {
  var monitoredThunk = action;
  monitoredThunk.monitorId = monitorId;
  return monitoredThunk;
}